import { DateInput, useTranslate } from 'react-admin';
import type { DateInputProps } from 'ra-ui-materialui';
import { InputLabel } from '@mui/material';

export const GrayDateInputWithUpperLabel = (props: DateInputProps) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label">
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <DateInput
        {...props}
        label={false}
        size={props.size}
        sx={[
          {
            mt: 0,
            mb: 0,
            '& fieldset': {
              border: 'none',
            },
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#f1f1f1 !important',
              boxSizing: 'border-box',
              height: props.size === 'small' ? 40 : 56,
              alignItems: 'center',
            },
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
        InputLabelProps={{
          ...props.InputLabelProps,
          shrink: true,
        }}
        inputProps={{
          ...props.inputProps,
          style: {
            backgroundColor: '#f1f1f1',
            borderRadius: '5px',
            ...props.inputProps?.style,
          },
        }}
      />
    </>
  );

};
